import { useState } from "react";

export const FigureImage = ({ src, alt }: { src: string; alt: string }) => {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  if (failed) return null;

  return (
    <div className="my-3 flex justify-center">
      {!loaded && (
        <div className="py-12 text-xs text-zinc-400">Loading figure…</div>
      )}
      <img
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        onError={() => setFailed(true)}
        className={[
          "max-w-full max-h-[600px] object-contain rounded",
          loaded ? "block" : "hidden",
        ].join(" ")}
      />
    </div>
  );
};
